import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import OnboardingErrors from '../../../../../Components/OnboardingErrors';
import SignUpFlowPicker from './SignUpFlowPicker';
import SignUpFlowStepIndicatorPicker from './SignUpFlowStepIndicatorPicker';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2, 3),
    paddingTop: theme.spacing(6),
    overflow: 'hidden',
  },
  content: {
    width: '100%',
    maxWidth: theme.dimensions.xl,
  },
});

const SignUpFlow = ({ classes }) => {
  return (
    <React.Fragment>
      <OnboardingErrors />
      <div className={classes.root}>
        <SignUpFlowStepIndicatorPicker />
        <div className={classes.content}>
          <SignUpFlowPicker />
        </div>
      </div>
    </React.Fragment>
  );
};

SignUpFlow.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SignUpFlow);
